import { useMemo } from "react";
import Box from "@mui/material/Box";
import GalleryItem from "../Gallery/GalleryItem";
import {
  acceptedFormatsPreview,
  buildAdMediaGalleryItem,
  getValidMediaUrls,
} from "./adMediaPreviewUtils";

const onNoop = () => {};

const AdMediaPreview = ({
  mediaUrls = [],
  onClick,
  onSelectPreview,
  sx = {},
  maxWidth = "100%",
}) => {
  const handleSelectPreview = onSelectPreview || onClick || onNoop;
  const validUrls = useMemo(() => getValidMediaUrls(mediaUrls), [mediaUrls]);
  const galleryItem = useMemo(
    () => buildAdMediaGalleryItem(validUrls),
    [validUrls]
  );

  const onOpenPreview = (event) => {
    if (event?.target?.closest?.("button")) {
      return;
    }

    handleSelectPreview();
  };

  if (!galleryItem) {
    return null;
  }

  return (
    <Box
      onClickCapture={onOpenPreview}
      sx={{
        width: "100%",
        maxWidth,
        containerType: "inline-size",
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "rgba(0, 0, 0, 0.04)",
        cursor: "pointer",
        ...sx,
      }}
    >
      <GalleryItem
        item={galleryItem}
        index={0}
        multiple={false}
        isSelected={false}
        showActionButtons={false}
        showDeleteButton={false}
        showDimensionsOverlay={false}
        showResizeFormatButton={false}
        overlayPickerMode={false}
        acceptedFormats={acceptedFormatsPreview}
        onSelectItem={onNoop}
        onSelectPreview={handleSelectPreview}
        onDeleteItem={onNoop}
        onDownloadItems={onNoop}
        onFailedLoadUrl={onNoop}
      />
    </Box>
  );
};

export default AdMediaPreview;
